import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const MailDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mail = location.state?.mail || {};

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Mail Details</h2>
      <div style={styles.card}>
        <div style={styles.row}>
          <span style={styles.label}>From:</span>
          <span style={styles.value}>{mail.from_user}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>To:</span>
          <span style={styles.value}>{mail.to_user}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Subject:</span>
          <span style={styles.value}>{mail.subject}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Date:</span>
          <span style={styles.value}>{mail.sent_at ? new Date(mail.sent_at).toLocaleString() : ''}</span>
        </div>
        <div style={styles.row}>
          <span style={styles.label}>Message:</span>
        </div>
        <div style={styles.messageBox}>
          {mail.message}
        </div>
        <button
          style={styles.backBtn}
          onClick={() => navigate('/inbox')}
        >
          ← Back to Inbox
        </button>
        <button
          style={styles.replyBtn}
          onClick={() =>
            navigate(`/replymail?email=${mail.from_user}`)
          }
        >
          Reply
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '14px',
    boxShadow: '0 1px 8px #e0cfa0',
    padding: '28px 22px 22px 22px',
    minHeight: '220px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    border: '2px solid #e0cfa0',
    position: 'relative',
  },
  row: {
    display: 'flex',
    gap: '12px',
    marginBottom: '6px',
    alignItems: 'center',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    minWidth: '90px',
    fontSize: '1.08rem',
  },
  value: {
    color: '#333',
    fontSize: '1.08rem',
    wordBreak: 'break-word',
  },
  messageBox: {
    background: '#fff',
    borderRadius: '8px',
    padding: '16px',
    fontSize: '1.08rem',
    color: '#333',
    minHeight: '80px',
    marginBottom: '18px',
    boxShadow: '0 1px 4px #e0cfa0',
    border: '1px solid #e0cfa0',
    wordBreak: 'break-word',
  },
  backBtn: {
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #e0cfa0',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginTop: '12px',
    alignSelf: 'center',
  },
  replyBtn: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '8px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    textDecoration: 'none',
    marginTop: '12px',
    alignSelf: 'center',
    marginLeft: '12px',
  },
};
export default MailDetails;
